import axios from "axios";
import { Dispatch } from "redux";
import baseUrl from "../../ApiConfig";
import { ProviderDoctorListActionTypes } from "./ActionTypes";
import { ProviderDoctorListRes, ProviderDoctorListBody } from "./Model";
import {
  providerDoctorListAPIResClearAction,
  providerDoctorListErrorAction,
  providerDoctorListLoadingAction,
  providerDoctorListSuccessAction,
  providerDoctorListUpdateAPIMsgAction,
} from "./Action";
import { headers } from "../../component/Utility";

let apiRes = {} as ProviderDoctorListRes;
export const providerDoctorList = (
  body: ProviderDoctorListBody,
  pageNo: number
) => {
  return function (dispatch: Dispatch<ProviderDoctorListActionTypes>) {
    dispatch(providerDoctorListLoadingAction(true));
    axios
      .post(
        baseUrl.baseUrl +
          `/providerorganizationapp/api/providerOrganizationDoctorList/get_doctorList_providerOrganization?size=50&page=${Number(
            pageNo
          )}`,
        body,
        { headers: headers }
      )
      .then((res) => {
        apiRes = res.data;
        dispatch(providerDoctorListLoadingAction(false));
        dispatch(providerDoctorListSuccessAction(res.data));
      })
      .catch((error) => {
        dispatch(providerDoctorListLoadingAction(false));
        dispatch(
          providerDoctorListErrorAction(
            {} as ProviderDoctorListRes,
            error.response !== undefined
              ? error.response.data.message
              : "Something went wrong",
            error.status !== undefined ? error.response.data.status || -1 : 0
          )
        );
      });
  };
};

export const updateproviderDoctorListAPIResMsg = () => {
  return function (dispatch: Dispatch<ProviderDoctorListActionTypes>) {
    dispatch(
      providerDoctorListUpdateAPIMsgAction(
        apiRes as ProviderDoctorListRes,
        "",
        0
      )
    );
  };
};

export const clearproviderDoctorListAPIRes = () => {
  return function (dispatch: Dispatch<ProviderDoctorListActionTypes>) {
    dispatch(
      providerDoctorListAPIResClearAction({} as ProviderDoctorListRes, "", 0)
    );
  };
};
